import { createPinia, storeToRefs } from 'pinia'

import '@/styles/app.css'
import { createApp } from 'vue'
import { createGtag } from 'vue-gtag'

import App from '@/App.vue'
import { ROUTES } from '@/config/ROUTES.ts'
import reveal from '@/extensions/reveal'
import i18n from '@/i18n'
import router from '@/router'
import { useContentStore } from '@/stores/content.ts'

const pinia = createPinia()

const app = createApp(App).use(router).use(pinia).use(i18n).use(reveal)

const contentStore = useContentStore()
const { options } = storeToRefs(contentStore)
app.config.globalProperties.$content = { options }

app.config.globalProperties.$routes = ROUTES

const gtagId = import.meta.env.VITE_APP_GTAG_ID
if (gtagId) {
  app.use(
    createGtag({
      tagId: gtagId,
      initMode: 'manual',
      pageTracker: {
        router,
      },
    }),
  )
}

app.mount('#app')
